// src/components/VideoRoom.js
import React, { useEffect, useRef } from 'react';
import { useOpenVidu } from '../contexts';
import { StreamHelper, VideoComponent } from './VideoComponent';
import './VideoRoom.scss'
import { Logger } from '../tools/logger';

const console = new Logger('VideoRoom', true)

export const VideoRoom = () => {
  const { publisher, subscribers, isMobile, joinSession } = useOpenVidu();
  const joinSessionRef = useRef(joinSession)
  joinSessionRef.current = joinSession
  useEffect(() => {
    setTimeout(() => {
      joinSessionRef.current()
    }, 1000)
  }, [])

  const styles = {
    container: {
      padding: isMobile ? '80px 10px 100px 10px' : '20px',
      background: '#f8f9fa',
      minHeight: '100vh',
      boxSizing: 'border-box',
    },
    title: {
      textAlign: 'center',
      color: '#333',
      marginBottom: '20px',
      fontSize: isMobile ? '20px' : '24px',
      fontWeight: '600',
    },
    videoGrid: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'center',
      gap: isMobile ? '8px' : '10px',
      maxWidth: '1400px',
      margin: '0 auto',
    },
    emptyState: {
      textAlign: 'center',
      color: '#666',
      fontSize: isMobile ? '16px' : '18px',
      marginTop: '50px',
    }
  };

  const allParticipants = [
    ...(publisher ? [{ streamManager: publisher, isPublisher: true }] : []),
    ...subscribers.map(subscriber => ({ streamManager: subscriber, isPublisher: false }))
  ];
  useEffect(() => {
    console.log('subscribers: ', subscribers.length)
    try {
      const helpers = subscribers.map(s => new StreamHelper(s).getInfo())
      console.log('subscribers (json):', JSON.stringify(helpers, null, 2))
    } catch (e) {
      console.log('subscribers error', e.message)
    }
  }, [subscribers])
  return (
    <div className={'video-room'}>
      {allParticipants.map((participant, index) => (
        <VideoComponent
          key={participant.streamManager.id || index}
          streamManager={participant.streamManager}
          isPublisher={participant.isPublisher}
          isMobile={isMobile}
        />
      ))}
      {!allParticipants.length ? (
        <div style={styles.emptyState}>
          Waiting for participants to join...
        </div>
      ) : null}
    </div>
  );
};
